import { mergeData } from 'vue-functional-data-merge'

import prefixPropName from '../../utils/prefix-prop-name'
import copyProps from '../../utils/copyProps'
import { assign } from '../../utils/object'
import cardMixin from '../../mixins/card-mixin'

export const props = assign(
  {},
  copyProps(cardMixin.props, prefixPropName.bind(null, 'header')),
  {
    header: {
      type: String,
      default: null
    },
    headerClass: {
      type: [String, Object, Array],
      default: null
    }
  }
)

export default {
  functional: true,
  props,
  render (h, { props, data, slots }) {
    return h(
      props.headerTag,
      mergeData(data, {
        staticClass: 'card-header',
        style: {
          'background-color': 'rgba(0,0,0,.03)',
          'border-bottom': '1px solid rgba(0, 0, 0, .125)',
          'verflow': 'hidden'
        },
        class: [
          props.headerClass,
          {
            [`bg-${props.headerBgVariant}`]: Boolean(props.headerBgVariant),
            [`border-${props.headerBorderVariant}`]: Boolean(
              props.headerBorderVariant
            ),
            [`text-${props.headerTextVariant}`]: Boolean(
              props.headerTextVariant
            )
          }
        ]
      }),
      slots().default || [
        props.header ? h('div', {
          domProps: { innerHTML: props.header },
          style: {
            float: props.headerOperation ? 'left' : '',
            width: props.headerOperation ? 'calc(100% - 56px)' : ''
          }
        }) : '',
        props.headerOperation ? h('div', {style: {'float': 'right', 'line-height': '25px', 'height': '21px', 'width': '56px'}}, [
          h('a', {
            on: {
              click: (e) => {
                e.target.getAttribute('class').indexOf('zmdi-plus') >= 0 ? e.target.className = 'zmdi font-18 pointer zmdi-minus' : e.target.className = 'zmdi font-18 pointer zmdi-plus'
                // e.target.getAttribute('class') === 'ti-plus pointer' ? e.target.className = 'ti-minus pointer' : e.target.className = 'ti-plus pointer'
                e.target.parentNode.parentNode.nextElementSibling.style.display === 'none' ? e.target.parentNode.parentNode.nextElementSibling.style.display = 'block' : e.target.parentNode.parentNode.nextElementSibling.style.display = 'none'
              }
            },
            class: ['zmdi', 'font-18', 'zmdi-minus', 'pointer']
          }),
          h('a', {
            style: {
              'margin-left': '10px'
            },
            on: {
              click: (e) => {
                e.target.getAttribute('class').indexOf('zmdi-fullscreen-exit') >= 0 ? e.target.className = 'zmdi font-18 pointer zmdi-fullscreen' : e.target.className = 'zmdi font-18 pointer zmdi-fullscreen-exit'
                e.target.parentNode.parentNode.parentNode.getAttribute('class').indexOf('card-fullscreen') >= 0 ? e.target.parentNode.parentNode.parentNode.classList.remove('card-fullscreen') : e.target.parentNode.parentNode.parentNode.classList.add('card-fullscreen')
              }
            },
            class: ['zmdi', 'font-18', 'zmdi-fullscreen', 'pointer']
          }),
          h('a', {
            style: {
              'margin-left': '10px'
            },
            on: {
              click: (e) => {
                e.target.parentNode.parentNode.parentNode.style.display = 'none'
              }
            },
            class: ['zmdi zmdi-close font-18', 'pointer']
          })
        ]) : ''
      ]
    )
  }
}



// WEBPACK FOOTER //
// ./src/components-base/components/card/card-header.js